import React, {Component} from 'react';


export default class Curriculum extends Component {
    render() {
        return (<div className="section" id="contact">
                <div className="cc-contact-information">
                    <div className="container">
                        <div className="cc-contact">
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="card mb-0" data-aos="zoom-in">
                                        <div className="h4 text-center title text-black">{this.props.texts.contact.getInTouch}</div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="card-body">
                                                    <form action="https://formspree.io/guilhermecamachop@gmail.com"
                                                          method="POST">
                                                        <div className="p pb-3"><strong>{this.props.texts.contact.sendMeAMessage}</strong></div>
                                                        <div className="row mb-3">
                                                            <div className="col">
                                                                <div className="input-group"><span className="input-group-addon"><i
                                                                    className="fa fa-user-circle"></i></span>
                                                                    <input className="form-control" type="text" name="name"
                                                                           placeholder={this.props.texts.contact.name} required="required"/>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row mb-3">
                                                            <div className="col">
                                                                <div className="input-group"><span className="input-group-addon"><i
                                                                    className="fa fa-file-text"></i></span>
                                                                    <input className="form-control" type="text" name="Subject"
                                                                           placeholder={this.props.texts.contact.subject} required="required"/>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row mb-3">
                                                            <div className="col">
                                                                <div className="input-group"><span className="input-group-addon"><i
                                                                    className="fa fa-envelope"></i></span>
                                                                    <input className="form-control" type="email" name="_replyto"
                                                                           placeholder="E-mail" required="required"/>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row mb-3">
                                                            <div className="col">
                                                                <div className="form-group">
                                                                <textarea className="form-control" name="message"
                                                                          placeholder={this.props.texts.contact.message}
                                                                          required="required"></textarea>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col">
                                                                <button className="btn btn-primary" type="submit">{this.props.texts.contact.send}</button>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}